import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { Estate } from '/@/modules/estate/models/Estate';
import { GenericModel } from '/@/modules/core/app/models/GenericModel';
import { EstateLiquidationProgress } from '/@/modules/estate/models/EstateLiquidationProgress';
import { PlanningProductStageCompletionDetail } from '/@/modules/estate/models/PlanningProductStageCompletionDetail';

export class EstateResource extends BaseResource {
  /**
   * @return {Promise<Estate>}
   */
  async getAllAccessibleEstates() {
    return this.getData(Route.ESTATES_ACCESSIBLEESTATES, Estate);
  }

  /**
   * @return {Promise<Estate>}
   */
  async getSelectionEstates(params) {
    return this.getData(Route.ESTATES_ACCESSIBLEESTATES_ESTATESELECTION, Estate, params);
  }

  /**
   * @param {number} estateId
   * @param {string} status
   * @param {?string} reasonForClosure
   * @return {Promise<boolean>}
   */
  async closeEstate(estateId, status, reasonForClosure) {
    return this.postData(Route.ESTATES_CLOSE_ESTATE, {
      estate_id: estateId,
      status,
      reasonForClosure
    });
  }

  /**
   * @param {number} estateId
   * @return {Promise<boolean>}
   */
  async restoreEstate(estateId) {
    return this.postData(Route.ESTATES_RESTORE_ESTATE, {
      estateId
    });
  }

  /**
   * @param {number} estateId
   * @param {Date} recurrenceStartDate
   * @return {Promise<boolean>}
   */
  async getAssetAverages(estateId, recurrenceStartDate) {
    return this.getData(Route.ESTATES_ASSET_AVERAGES, GenericModel, {
      estate_id: estateId,
      recurrence_start_date: recurrenceStartDate
    });
  }

  /**
   * @param params
   * @returns {Promise<EstateLiquidationProgress>}
   */
  async getLiquidationProgress(params) {
    return this.getData(Route.ESTATES_LIQUIDATIONPROGRESS, EstateLiquidationProgress, params);
  }

  /**
   * @param params
   * @returns {Promise<PlanningProductStageCompletionDetail>}
   */
  async getPlanningProductStageCompletionDetail(params) {
    return this.getData(
      Route.ESTATES_STAGEDATA_PLANNING,
      PlanningProductStageCompletionDetail,
      params
    );
  }

  /**
   * @param {number} estateId
   * @param {number | null} teamId
   * @return {Promise<void>}
   */
  async moveEstateToTeam(estateId, teamId) {
    return this.postData(Route.ESTATES_MOVE_TO_TEAM, {
      estateId,
      teamId
    });
  }
}

export default new EstateResource();
